import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import * as Actions from './OrdersActions';
import { handleError } from '../../shared/ErrorCatching';
import { sanitizeAgreementHtml } from '../../shared/agreementHtml';

interface IProps {
    agreementKey: number;
    agreement: string;
    close: () => void;
    actions: IActions;
}

interface IActions {
    getAgreement: (agreementKey: number) => Promise<any>;
}

interface IState {
    isInitialized: boolean;
}

class AgreementModal extends React.Component<IProps, IState> {
    constructor(props: IProps, context: any) {
        super(props, context);

        this.state = {
            isInitialized: false
        };
    }

    componentDidMount(): void {
        this.props.actions
            .getAgreement(this.props.agreementKey)
            .then(() => this.setState({ isInitialized: true }))
            .catch((error: any) => handleError(error));
    }

    render(): any {
        return (
            <Modal show={true} onHide={this.props.close}>
                <Modal.Header closeButton>
                    <Modal.Title>{Translate('orders/create/agreement-modal/title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: sanitizeAgreementHtml(this.props.agreement)
                        }}
                    ></div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.close}>
                        {Translate('orders/create/agreement-modal/button-labels/close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        agreement: state.orders.create.agreement
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getAgreement: (agreementKey: number) => dispatch(Actions.getAgreement(agreementKey))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementModal);
